import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { setToasterMessage } from 'store/globalSlice';
import { useRbTexts } from 'remote-state/applicationHooks';

const useShowSelectMainCategoryPopup = ():{ showSelectMainCategoryPopup: () => void } => {
  const dispatch = useDispatch();
  const texts = useRbTexts();
  const selectMainCategoryText = useMemo(
    () => texts?.['spaces.categories.selectMainCategory'] || 'Please select the main category first',
    [texts],
  );

  const showSelectMainCategoryPopup = () => {
    dispatch(setToasterMessage({
      message: selectMainCategoryText,
      showFor: 5000,
    }));
  }
  return { showSelectMainCategoryPopup };
};

export default useShowSelectMainCategoryPopup;